import React from "react";
//#region types
import { NumberChartProps } from "models/propTypes/chartProps";
import { GraphConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const NumberChart: React.FC<NumberChartProps> = (props) => {
  return (
    <Grid className={cssExports.numberChartContainer}>
      <Grid container justifyContent={"center"}>
        <Icon icon={props.icon} className={cssExports.numberChartIcon} />
      </Grid>
      <Grid container justifyContent={"center"} className={cssExports.numberChartValue}>
        {`${LocalizationHelperInstance.getFormattedNumber(props.data, 0, 2)} ${
          props.dataUnit ?? GraphConstants.DefaultDataUnit
        }`}
      </Grid>
      <Grid container justifyContent={"center"} className={cssExports.numberChartText}>
        {props.title}
      </Grid>
    </Grid>
  );
};

export default NumberChart;
